module.exports = __webpack_public_path__ + "img/route-in.fc372804.svg";